import { render, staticRenderFns } from "./HrSetup.vue?vue&type=template&id=53438df9&scoped=true&"
import script from "./HrSetup.vue?vue&type=script&lang=js&"
export * from "./HrSetup.vue?vue&type=script&lang=js&"
import style0 from "./HrSetup.vue?vue&type=style&index=0&id=53438df9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53438df9",
  null
  
)

export default component.exports